export default "__VITE_ASSET__DzIC5dFR__"